function switchMagentoVersion(version) {
    var magentoV1Access = document.getElementById('magento_v1_api_access');
    var magentoV1AccessSetting = document.getElementById('magento_v1_api_access_setting');
    var magentoV1Elements = document.querySelectorAll('.magento_v1');
    var magentoV2Access = document.getElementById('magento_v2_api_access');

    if (version === 'v1') {
        magentoV1Access.style.display = 'block';
        magentoV1AccessSetting.style.display = 'block';
        magentoV2Access.style.display = 'none';
        magentoV1Elements.forEach(function(element) {
            element.style.display = 'block';
        });
    } else {
        magentoV1Access.style.display = 'none';
        magentoV1AccessSetting.style.display = 'none';
        magentoV2Access.style.display = 'block';
        magentoV1Elements.forEach(function(element) {
            element.style.display = 'none';
        });
    }
}

compiler('[form-magento-shop-setting-switch-version]', function(form) {
    form.addEventListener('change', function(event) {
        target = event.target;
        if (target && target.matches('[data-switch-magento-version]')) {
            switchMagentoVersion(target.value);
        }
    });

    var magentoVersionRadios = form.querySelectorAll('[data-switch-magento-version]:checked');
    switchMagentoVersion(magentoVersionRadios[0].value)
});